export enum Scripts {
    LiveChat = 'livechat',
    Adobe = 'adobe',
    Config = 'config',
    UpdateBillingSdk = 'update-billing-sdk'
}